// Follow asynchronous growth (summaries, transcripts, media) only while pinned.
// Observe message boxes, not the fixed-height scrolling viewport.
export function followGrowingMessages(el: HTMLElement) {
 let pinned = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
 let height = el.scrollHeight;
 let touching = false;
 const boxes = new Map<Element, number>();
 const onScroll = () => {
  // A layout change can emit scroll before ResizeObserver. Keep the pre-growth
  // intent until that resize is handled.
  if (el.scrollHeight === height)
   pinned = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
 };
 const onWheel = (event: WheelEvent) => { if (event.deltaY < 0) pinned = false; };
 const onTouch = () => { touching = true; pinned = false; };
 const onTouchEnd = () => { touching = false; };
 const resize = new ResizeObserver(entries => {
  let grew = false;
  for (const entry of entries) {
   const previous = boxes.get(entry.target);
   const next = entry.target.getBoundingClientRect().height;
   if (previous !== undefined && next > previous + 0.5) grew = true;
   boxes.set(entry.target, next);
  }
  if (grew && pinned && !touching) el.scrollTop = el.scrollHeight - el.clientHeight;
  height = el.scrollHeight;
 });
 const sync = () => {
  for (const child of Array.from(el.children)) {
   if (!boxes.has(child)) {
    boxes.set(child, child.getBoundingClientRect().height);
    resize.observe(child);
   }
  }
  for (const child of boxes.keys()) {
   if (child.parentElement !== el) { resize.unobserve(child); boxes.delete(child); }
  }
  // Insertions/prepends retain the existing pagination/auto-scroll handling.
  height = el.scrollHeight;
 };
 const mutations = new MutationObserver(sync);
 sync();
 mutations.observe(el, { childList: true });
 el.addEventListener('scroll', onScroll, { passive: true });
 el.addEventListener('wheel', onWheel, { passive: true });
 el.addEventListener('touchstart', onTouch, { passive: true });
 el.addEventListener('touchend', onTouchEnd, { passive: true });
 el.addEventListener('touchcancel', onTouchEnd, { passive: true });
 return () => {
  resize.disconnect(); mutations.disconnect();
  el.removeEventListener('scroll', onScroll);
  el.removeEventListener('wheel', onWheel);
  el.removeEventListener('touchstart', onTouch);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchEnd);
 };
}
